import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import DataTablePageDynamic from '../../../../component/Table/DataTablePageDynamic';
import { formatCurrency } from '../../../../helpers/CurrencyInput';

const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

const CashTransactionGroup = ({ data }) => {
    const totalDebit = data.accounts.reduce((sum, a) => sum + parseFloat(a.debit || 0), 0);
    const totalCredit = data.accounts.reduce((sum, a) => sum + parseFloat(a.credit || 0), 0);

    return (
        <div className="border-b mb-4">
            <h3 className="bg-blue-400 text-white p-2 font-bold">
                Bank Deposit {data.deposit_number} | {data.date} (created on {data.created_at})
            </h3>
            <table className="w-full text-sm">
                <tbody>
                    {data.accounts.map((acc, idx) => (
                        <tr key={idx} className="border-t">
                            <td className="w-1/2 p-2">
                                <strong>({acc.code}) - {acc.name}</strong><br />
                                {acc.description}
                            </td>
                            <td className="w-1/4 p-2 text-right">{formatCurrency(acc.debit)}</td>
                            <td className="w-1/4 p-2 text-right">{formatCurrency(acc.credit)}</td>
                        </tr>
                    ))}
                    <tr className="bg-gray-100 font-bold">
                        <td className="p-2 text-right">Total</td>
                        <td className="p-2 text-right">{formatCurrency(totalDebit)}</td>
                        <td className="p-2 text-right">{formatCurrency(totalCredit)}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

const ReportJournal = () => {
    const navigate = useNavigate();
    const [keys, setKeys] = useState([]);
    const [columns, setColumns] = useState([]);

    const [totalRows, setTotalRows] = useState(0);
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [pageText, setPageText] = useState(0);

    const [data, setData] = useState([]);
    const [isNextPage, setIsNextPage] = useState(true);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_REPORT = "api/erpppsu/report/journal";

    const [filterFirstDate, setFilterFirstDate] = useState(getTodayDate());
    const [filterLastDate, setFilterLastDate] = useState(getTodayDate());

    // Fetch data from the API
    const fetchData = async (URL, config) => {
        try {
            const response = await axios.get(URL, config);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(`${BASE_URL}${PATH_REPORT}?first_date=${filterFirstDate}&last_date=${filterLastDate}`, {
            params: {
                offset: pageIndex,
                limit: pageSize
            }
        }).then((data) => {
            setData(data.data);
            setTotalRows(data.total);
        });
    }, []);

    useEffect(() => {
        setKeys(data.length > 0 ? Object.keys(data[0]) : []);
    }, [data]);

    useEffect(() => {
        setColumns(keys.map(key => ({
            Header: key.charAt(0).toUpperCase() + key.slice(1),
            accessor: key
        })));
    }, [keys]);

    useEffect(() => {
        setPageIndex(pageIndex);
        fetchData(`${BASE_URL}${PATH_REPORT}?first_date=${filterFirstDate}&last_date=${filterLastDate}`, {
            params: {
                offset: pageIndex,
                limit: pageSize
            }
        }).then((data) => {
            setIsNextPage(data.more > 0);
            setData(data.data);
            setTotalRows(data.total);
        });
    }, [pageIndex, pageSize]);

    const handleFilter = () => {
        if (filterFirstDate && filterLastDate) {
            fetchData(`${BASE_URL}${PATH_REPORT}?first_date=${filterFirstDate}&last_date=${filterLastDate}`, {
                params: {
                    offset: pageIndex,
                    limit: pageSize
                }
            }).then((data) => {
                setIsNextPage(data.more > 0);
                setData(data.data);
                setTotalRows(data.total);
            });
        }
    };

    if (error) {
        return <div>Error: {error}</div>;
    }



    return (
        <div>
            <div className='flex items-center justify-between'>
                <h2 className="text-2xl font-bold mb-4">Laporan Jurnal</h2>

                <div className='flex items-center'>
                    {/* <ButtonOptionGroup
                        label={"Buat Penjualan Baru"}
                        options={options}
                        onChange={(value) => {
                            navigate(`/activity-erpppsu/sales/new/${value}`);
                        }}
                    /> */}
                </div>
            </div>

            <div className="container m-auto grid grid-cols-5 sm:grid-cols-2 xs:grid-cols-1 md:grid-cols-3 lg:grid-cols-5 my-3 gap-4">
                {/* First Date Input */}
                <div className="mx-1">
                    <label htmlFor="first_date" className="block mb-1 text-sm font-semibold">
                        Tanggal Awal
                    </label>
                    <input
                        id="first_date"
                        name="first_date"
                        type="date"
                        className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                        value={filterFirstDate}
                        onChange={(e) => setFilterFirstDate(e.target.value)}
                    />
                </div>

                {/* Last Date Input */}
                <div className="mx-1">
                    <label htmlFor="last_date" className="block mb-1 text-sm font-semibold">
                        Tanggal Akhir
                    </label>
                    <input
                        id="last_date"
                        name="last_date"
                        type="date"
                        className="my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                        value={filterLastDate}
                        onChange={(e) => setFilterLastDate(e.target.value)}
                    />
                </div>

                {/* Filter Button */}
                <div className="p-3 flex items-end">
                    <button
                        onClick={handleFilter}
                        type="button"
                        className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200"
                    >
                        Filter
                    </button>
                </div>
            </div>

            {loading ? (
                <center><h1>Loading...</h1></center>
            ) : (
                data.map((group, idx) => (
                    <CashTransactionGroup key={idx} data={group} />
                ))
            )}

            <div className="pagination-container">
                <button
                    className="pagination-button"
                    onClick={() => {
                        setPageText(prev => Math.max(prev - 1));
                        setPageIndex(prev => Math.max(prev - pageSize, 0));
                    }}
                    disabled={pageIndex == 0}
                >
                    Previous
                </button>
                <span className="pagination-info">
                    Page {pageText + 1}
                </span>
                <button
                    className="pagination-button"
                    onClick={() => {
                        setPageText(prev => Math.max(prev + 1));
                        setPageIndex(prev => Math.max(prev + pageSize));
                    }}
                    disabled={!isNextPage}
                >
                    Next
                </button>
            </div>


            <p>
            Menampilkan {Math.min(pageSize + pageIndex, totalRows)} dari {totalRows} Baris
            </p>
        </div>
    )
}

export default ReportJournal;
